export default {
  inputRoot: {
    background: '#fff'
  }
}
